module.exports = __webpack_public_path__ + "static/media/1Asset-13Intros.e7c04b2f.png";